module.exports = __webpack_public_path__ + "media/images/flags/io-3172438b78785779bd27905afb605a3f.svg";